import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import Button from '../../components/ui/Button';
import { ROTAS } from '@/routes/routePaths';
import { PROMOCAO, REGRAS_PROMOCAO } from '@/constants/promocao';

const TermosCondicoesPage: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div className="min-h-screen flex items-center justify-center p-4 relative overflow-hidden">
            <div className="fixed inset-0 z-0">
                <img src="/Background-secao2.png" alt="Background" className="w-full h-full object-cover" />
                <div className="absolute inset-0 bg-black/20"></div>
            </div>

            <motion.div
                initial={{ opacity: 0, y: -50 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.5 }}
                className="relative z-10 bg-background/95 backdrop-blur-sm p-6 rounded-lg shadow-2xl max-w-4xl w-full border border-primary overflow-hidden max-h-[90vh]"
            >
                <div className="absolute inset-0 z-0">
                    <img src="/BG.png" alt="Background do card" className="w-full h-full object-cover opacity-30" />
                    <div className="absolute inset-0 bg-black/5"></div>
                </div>

                <div className="relative z-20">
                    <div className="flex justify-center mb-6">
                        <Link to={'/'}>
                            <img src={'/clube.png'} alt="Mr Tugas Logo" className='h-32 object-contain' />
                        </Link>
                    </div>

                    <h2 className="text-3xl font-bold text-center text-primary mb-6">
                        Termos e Condições - Clube Mr Tugas
                    </h2>

                    <div className="rounded-lg p-6 max-h-[60vh] overflow-y-auto">
                        <div className="space-y-6 text-sm text-white">
                            <section>
                                <h3 className="text-lg font-semibold text-primary mb-3">1. Definições</h3>
                                <ul className="space-y-2 ml-4">
                                    <li><strong>Tugas Coin (TC):</strong> Moeda virtual do Clube Mr Tugas, onde 1 TC equivale a R$ 1,00.</li>
                                    <li><strong>Estabelecimentos Participantes:</strong> Lojas físicas Mr Tugas ( Aeroporto e Jardim Norte ) que aceitam Tugas Coin.</li>
                                    <li><strong>Usuário:</strong> Cliente cadastrado no Clube Mr Tugas.</li>
                                </ul>
                            </section>

                            <section>
                                <h3 className="text-lg font-semibold text-primary mb-3">2. Funcionamento do Tugas Coin</h3>
                                <p className="mb-2">O acúmulo de Tugas Coin ocorre mediante compras ou promoções específicas, conforme regras divulgadas no ato da transação.</p>
                                <p className="mb-2">O saldo de Tugas Coin é registrado automaticamente no sistema do Clube Mr Tugas e pode ser consultado pelo usuário via plataforma web.</p>
                                <p className="font-semibold mb-2">Não é permitido:</p>
                                <ul className="list-disc ml-6 space-y-1">
                                    <li>Utilizar Tugas Coin na Unidade Mr Tugas Delivery</li>
                                    <li>Utilizar Tugas Coin no delivery de chope e no delivery de pizza</li>
                                    <li>Resgatar Tugas Coin em dinheiro (saque)</li>
                                    <li>Transferir Tugas Coin para terceiros</li>
                                    <li>Utilizar Tugas Coin fora dos Estabelecimentos participantes</li>
                                </ul>
                            </section>

                            <section>
                                <h3 className="text-lg font-semibold text-primary mb-3">3. {PROMOCAO.nome}</h3>
                                <ul className="list-disc ml-6 space-y-1">
                                    {REGRAS_PROMOCAO.map((regra) => (
                                        <li key={regra}>{regra}</li>
                                    ))}
                                </ul>
                            </section>

                            <section>
                                <h3 className="text-lg font-semibold text-primary mb-3">4. Uso e Validade</h3>
                                <p className="mb-2">Tugas Coin só podem ser utilizadas para abater valores em compras nos Estabelecimentos Mr Tugas.</p>
                                <p className="mb-2">O saldo será debitado automaticamente ao finalizar uma compra, se o usuário optar por usar Tugas Coin.</p>
                                <p>As Tugas Coin <strong>não têm data de validade</strong>: o saldo pode ser usado de uma vez ou aos poucos, até acabar.</p>
                            </section>

                            <section>
                                <h3 className="text-lg font-semibold text-primary mb-3">5. Regras Gerais</h3>
                                <p className="mb-2">O Clube Mr Tugas reserva-se o direito de:</p>
                                <ul className="list-disc ml-6 space-y-1 mb-2">
                                    <li>Alterar as regras de acúmulo, uso ou expiração mediante aviso prévio</li>
                                    <li>Suspender contas em caso de uso fraudulento</li>
                                </ul>
                                <p>Casos não previstos serão resolvidos pela administração do Clube Mr Tugas.</p>
                            </section>

                            <section>
                                <h3 className="text-lg font-semibold text-primary mb-3">6. Cancelamento e Inatividade</h3>
                                <p className="mb-2">Em caso de cancelamento do cadastro, o saldo de Tugas Coin será perdido.</p>
                                <p>Contas inativas por <strong>24 meses</strong> serão desativadas automaticamente, e o saldo remanescente será zerado.</p>
                            </section>

                            <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4 mt-6">
                                <p className="text-sm text-yellow-800 text-center">
                                    <strong>Última atualização:</strong> {new Date().toLocaleDateString('pt-BR')}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div className="absolute justify-center mt-6 z-50">
                        <Button
                            tipo="primary"
                            onClick={() => { navigate('/'); }}
                            className="px-8 py-2"
                        >
                            Voltar
                        </Button>
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default TermosCondicoesPage;